export default "__VITE_ASSET__Aa61ipye__";